<template>
  <Navbar></Navbar>
  <div class="product-detail-page">
    <div class="detail-banner">
      <div class="img-box detail-banner-img"><img src="/assets/product/engine/4D24/4D24.jpg" alt=""></div>
      <div class="detail-banner-r">
        
        <div class="detail-banner-t2">4D24 2.4T柴油发动机</div>
        <div class="detail-banner-desc">
          全新一代2.4T高性能低油耗柴油发动机（可选电控硅油风扇和电子风扇配置）。
        </div>
      </div>
    </div>
  </div>

  <div class="detail-box">
    <div class="detail-title">强动力</div>
    <div class="detail-desc">最大扭矩起始转速低、持续转速范围广，加速平顺、动力充足，提升行驶质感。</div>
    <div class="detail-utils">
      <div class="detail-utils-item">
        <div class="detail-utils-d">最大功率</div>
        <div class="detail-utils-u">137kW 3600r/min</div>
      </div>
      <div class="detail-utils-item">
        <div class="detail-utils-d">最大扭矩</div>
        <div class="detail-utils-u">490N·m 1500~2500r/min</div>
      </div>
      <div class="detail-utils-item">
        <div class="detail-utils-d">低速扭矩</div>
        <div class="detail-utils-u">1000r/min 260N·m，1200r/min 350N·m</div>
      </div>
    </div>

    <div class="detail-swiper-list detail-box">
      <div class="img-box detail-swiper-right ">
        <img src="/assets/product/engine/4D24/4D24-1.jpg" alt=""></img>
      </div>
      <div class="detail-swiper-left">
        <div>
          <div class="detail-title">
            高效电控VGT增压器
          </div>
          <!-- <div class="detail-desc">
                      充气效率提升20%，低速动力提升30%，1000r/min扭矩260N·m。
                  </div> -->
        </div>
        <div class="detail-swiper-utils">
          <div class="detail-swiper-util-item">
            <div class="detail-swiper-n">
              20%
            </div>
            <div class="detail-swiper-d">
              充气效率提升
            </div>
          </div>
          <div class="detail-swiper-util-item">
            <div class="detail-swiper-n">
              30%
            </div>
            <div class="detail-swiper-d">
              低速动力提升
            </div>
          </div>
          <div class="detail-swiper-util-item">
            <div class="detail-swiper-n">
              260N·m
            </div>
            <div class="detail-swiper-d">
              扭矩（1000r/min）
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="detail-box">
    <div class="detail-title">低油耗</div>
    <div class="detail-desc">全新设计柱状燃烧室、高效率双切向气道，匹配2000bar高压共轨系统，合理应用高、低压EGR，多项减摩降损措施，燃烧更充分，油耗更低。</div>
    <div class="detail-four-list">
      <div class="detail-four-item">
        <div class="img-box">
          <img src="/assets/product/engine/4D24/4D24-2.jpg" alt=""></img>
        </div>
      </div>
      <div class="detail-four-item">
        <div class="detail-four-title">
          进气系统优化
        </div>
        <div class="detail-four-desc">
          双切向进气道、优化进气形态，涡流比提升63%，显著提升燃油经济性。
        </div>
        <div class="detail-four-units">
          <div class="detail-four-unit-item">
            <div class="detail-four-u">
              63
              <span>
                %
              </span>
            </div>
            <div class="detail-four-d">
              涡流比提升
            </div>
          </div>
        </div>
      </div>
      <div class="detail-four-item">
        <div class="detail-four-title">
          高压共轨系统
        </div>
        <div class="detail-four-desc">
          2000bar系统压力配合高速电磁式喷油器，燃烧更充分。
        </div>

      </div>
      <div class="detail-four-item">
        <div class="img-box">
          <img src="/assets/product/engine/4D24/4D24-3.jpg" alt=""></img>
        </div>
      </div>
    </div>
  </div>


  <div class="detail-box detail-bottom-bgs">

    <div class="detail-updown-list">
      <div class="detail-updown-item">
        <div class="detail-updown-title">
          变排量机油泵
        </div>
        <div class="detail-updown-desc">
          按需调控机油压力，节省燃油，油耗降低0.8%
        </div>
        <div class="img-box">
          <img src="/assets/product/engine/4D24/4D24-4.jpg" alt=""></img>
        </div>
      </div>
      <div class="detail-updown-item">
        <div class="detail-updown-title">
          高、低压EGR
        </div>
        <div class="detail-updown-desc">
          高+低压EGR技术，配合紧耦合后处理，整车油耗降低2%。
        </div>
        <div class="img-box">
          <img src="/assets/product/engine/4D24/4D24-5.jpg" alt=""></img>
        </div>
      </div>
    </div>
  </div>


  <div class="detail-box">
    <div class="detail-title">NVH</div>
    <div class="detail-desc">以打造最好听的柴油机为目标，从主被动两方面提升开发，媲美汽油机NVH体验。</div>
    <div class="detail-four-list">
      <div class="detail-four-item">
        <div class="img-box">
          <img src="/assets/product/engine/4D24/4D24-6.jpg" alt=""></img>
        </div>
      </div>
      <div class="detail-four-item">
        <div class="detail-four-title">
          并联结合消隙齿轮凸轮轴
        </div>
        <div class="detail-four-desc">
          双顶置并联消隙齿轮驱动凸轮轴，齿轮振动改善74%，发动机齿轮敲击噪声降低4~5dBA。
        </div>

      </div>
      <div class="detail-four-item">
        <div class="detail-four-title">
          正时系统
        </div>
        <div class="detail-four-desc">
          合理匹配带轮相位，降低正时皮带张力，改善啮合噪声，皮带系统噪声低，配合上塑下铝正时罩盖，高效屏蔽高低频噪声。
        </div>

      </div>
      <div class="detail-four-item">
        <div class="img-box">
          <img src="/assets/product/engine/4D24/4D24-7.jpg" alt=""></img>
        </div>
      </div>
    </div>
  </div>


  <div class="detail-box detail-bottom-bgs">

    <div class="detail-updown-list">
      <div class="detail-updown-item">
        <div class="detail-updown-title">
          后端齿圈驱动平衡轴
        </div>
        <div class="detail-updown-desc">
          匹配平衡轴，提升NVH舒适性，曲轴后端齿轮驱动，降低扭振激励，降齿轮噪声，整机机械噪声降低2dBA。
        </div>
        <div class="img-box">
          <img src="/assets/product/engine/4D24/4D24-8.jpg" alt=""></img>
        </div>
      </div>
      <div class="detail-updown-item">
        <div class="detail-updown-title">
          燃油系统、发动机顶端隔音降噪
        </div>
        <div class="detail-updown-desc">
          高压油泵、高压油轨及喷油器被动降噪包裹，采用离火自熄阻燃材质，随形包裹设计并选取合适密度，实现优秀的隔音降噪效果。
        </div>
        <div class="img-box">
          <img src="/assets/product/engine/4D24/4D24-9.jpg" alt=""></img>
        </div>
      </div>
    </div>
  </div>


  <Footer></Footer>
</template>

<script setup>
import { ref, nextTick, onMounted } from 'vue';
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';
const swiperInstances = ref({});

onMounted(() => {
  nextTick(() => {
    const swiperContainers = document.querySelectorAll('.swiper-container');

    swiperContainers.forEach((container, index) => {
      const containerKey = `swiper_${index}`;
      container.dataset.swiperKey = containerKey;
      const swiperInstance = new Swiper(container, {
        loop: false,
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 300,
        preventClicks: true,
        effect: 'fade',
      });
      swiperInstances.value[containerKey] = swiperInstance;
    });

    bindTabClickEvent();
  });
});
function bindTabClickEvent() {
  const allSwiperLists = document.querySelectorAll('.detail-swiper-list');

  allSwiperLists.forEach((swiperList) => {
    const tabItems = swiperList.querySelectorAll('.detail-tab-item');
    const targetSwiperContainer = swiperList.querySelector('.swiper-container');

    if (!tabItems.length || !targetSwiperContainer) return;

    const containerKey = targetSwiperContainer.dataset.swiperKey;
    const targetSwiper = swiperInstances.value[containerKey];
    if (!targetSwiper) return;

    const handleTabAction = (tabItem, localTabIndex) => {
      tabItems.forEach(item => item.classList.remove('active'));
      tabItem.classList.add('active');
      targetSwiper.slideTo(localTabIndex, 300, true);
    };
    tabItems.forEach((tabItem, localTabIndex) => {
      const handleTabClickWrapper = () => {
        handleTabAction(tabItem, localTabIndex);
      };
      tabItem.removeEventListener('click', handleTabClickWrapper);
      tabItem.removeEventListener('mouseenter', handleTabClickWrapper);
      tabItem.addEventListener('click', handleTabClickWrapper);
      tabItem.addEventListener('mouseenter', handleTabClickWrapper);
    });
  });
}

</script>

<script>
export const pageConfig = {
  title: '4D24 2.4T柴油发动机 - 蜂巢汽车官网',
  keywords: '蜂巢,蜂巢汽车,发动机,变速箱,电子',
  description: '蜂巢汽车科技集团有限公司，是一家掌握从传统动力到混合动力再到纯电动力（含控制器）全领域动力总成、汽车智能化集成系统等核心技术的零部件企业，具备完整的软、硬件产业链；能为客户提供高效节能环保的汽车动力总成、智能化出行解决方案',
  outputPath: 'engine/4D24.html'
};

import { createApp } from 'vue';
import App from './4D24.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss"
import "@/assets/styles/product-details.scss"

function mountApp() {
  const appNode = document.getElementById('app');
  if (appNode) {
    if (appNode._vueApp) {
      appNode._vueApp.unmount();
      delete appNode._vueApp;
    }
    const app = createApp(App);
    app.use(store);
    appNode._vueApp = app.mount(appNode);
  }
}

// 页面加载完成后挂载
document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
  module.hot.accept('./4D24.vue', () => {
    mountApp();
  });
}
</script>

<style lang="scss" scoped></style>